/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { Form } from 'app/components/ui/form';
import Title from '../form/title';
import Editor from '../form/editor';
import PageAttributes from '../form/page-attributes';
import Status from '../form/status';
import Categories from '../form/categories';
import Tags from '../form/tags';
import { Button } from 'app/components/ui/button';
import Excerpt from '../form/excerpt';
import { useBlogsSlice } from '../../slice';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import FeaturedImage from '../form/featured-inage';

function EditBlog() {
  const form = useForm({
    defaultValues: {
      status: 1,
    },
  });

  const { useAddBlogsMutation, useGetBlogByIdQuery } = useBlogsSlice();
  const [addBlogs, { data, isLoading, error }] = useAddBlogsMutation();
  const [getBlog, { data: blogData }] = useGetBlogByIdQuery();

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getBlog(id);
    }
  }, [id]);

  useEffect(() => {
    if (blogData) {
      let d = blogData?.data;
      Object.keys(d).forEach(key => {
        form.setValue(key, d[key]);
      });
    }
  }, [blogData]);

  const handleSubmit = () => {
    addBlogs(form.getValues());
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      toast({
        title: 'Blog updated successfully',
        description: 'Blog updated successfully',
      });
      navigate('/blogs');
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      toast({
        title: 'Blog updated failed',
        description: 'Blog updated failed',
      });
    }
  }, [error]);

  return (
    <div className="bg-gray-100 min-h-screen blogs">
      <div className="flex justify-between items-center mb-5">
        <h1>Edit Blog</h1>
        <div>
          <Button onClick={handleSubmit} disabled={isLoading}>
            Save{' '}
          </Button>
        </div>
      </div>
      <Form {...form}>
        <form>
          <div className="flex">
            <div className="w-[75%]">
              <div className="mr-[30px]">
                <Title />
                <Editor />
                <Excerpt />
              </div>
            </div>

            <div className="w-[25%] space-y-4">
              <Status />
              <Categories />
              <Tags />
              <PageAttributes />
              <FeaturedImage />
            </div>
          </div>
        </form>
      </Form>
      <div className="h-10"></div>
    </div>
  );
}
export default EditBlog;
